import HelpOutline from '@mui/icons-material/HelpOutline'
import { SxProps, Theme } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import { styled } from '@mui/material/styles'
import Tooltip, { TooltipProps } from '@mui/material/Tooltip'
import { ReactNode } from 'react'

interface HintLabelProps {
  hint?: ReactNode
  children?: ReactNode
  shrink?: boolean
  htmlFor?: string
  sx?: SxProps<Theme>
  placement?: TooltipProps['placement']
}

const HintLabel = ({
  hint,
  shrink = true,
  htmlFor,
  children,
  sx,
  placement = 'top',
}: HintLabelProps) => {
  if (!hint && !children) return null

  return (
    <InputLabel
      htmlFor={htmlFor}
      shrink={shrink}
      sx={{ display: 'flex', alignItems: 'flex-start', ...sx }}
    >
      {hint ? (
        <Tooltip title={hint} arrow placement={placement}>
          <CenteredDiv>
            {children}{' '}
            <HelpOutline style={{ fontSize: '16px', marginLeft: 5 }} />
          </CenteredDiv>
        </Tooltip>
      ) : (
        children
      )}
    </InputLabel>
  )
}

export default HintLabel

const CenteredDiv = styled('div')`
  display: flex;
  align-items: center;
`
